define('configuration/routes.configuration',['require','exports','module','fukit/fukit','routes'],function(require, exports, module) {
  //prettier-ignore
  var routeConfigHandler = require('fukit/fukit').RouteConfiguration,
      routes             = require('routes');

  var RouteConfiguration = {
    radioEvents: {
      'app configure': 'onAppConfigure',
    },

    routes: routes,

    onAppConfigure: routeConfigHandler,
  };

  module.exports = RouteConfiguration;
});

